module.exports = __webpack_public_path__ + "media/npc_dota_hero_axe.59ecac65.webm";